import React from 'react';
import Tooltip from './Tooltip';

interface TruncatedCellProps {
  text: string | null | undefined;
  className?: string;
  tooltipClassName?: string;
  /** number of lines to clamp to; default 1 (single-line ellipsis) */
  lines?: number;
}

// Truncated cell that uses Tooltip wrapper (fallback to native title). Focusable and accessible.
const TruncatedCell: React.FC<TruncatedCellProps> = ({ text, className = '', tooltipClassName = '', lines = 1 }) => {
  const value = text || '';

  const multiLineClass = lines > 1 ? 'truncate-multiline' : 'truncate-mono';

  return (
    <Tooltip content={value} side="top" align="start">
      <span
        className={`${multiLineClass} overflow-hidden ${className}`}
        aria-label={value}
        tabIndex={0}
        data-tooltip-class={tooltipClassName}
      >
        {value}
      </span>
    </Tooltip>
  );
};

export default TruncatedCell;
